<template>
  <v-row>
    <v-col cols="12"
           class="d-flex align-center justify-center"
           :style="{ height }">
      <div class="d-flex flex-column align-center">
        <v-progress-circular indeterminate color="kbBlue" :width="0.09 * circleSize" :size="circleSize" />
        <span class="kbDarkBlueText--text text-center font-weight-medium d-block mt-3"
              style="font-size: 22px">
          {{ message }}
        </span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import i18n from '@/plugins/i18n/index'
export default {
  props: {
    circleSize: {
      type: Number,
      default: 120
    },
    height: {
      type: String,
      default: '85vh'
    },
    message: {
      type: String,
      default: i18n.t('general.loadingInformation')
    }
  }
}
</script>
